import React, { useEffect, useState } from "react";
import { Model, UseForm } from "../../../hooks";
import { useTranslation } from "react-i18next";
import { action, controller, Server } from "../../../api/Server";
import { ToFormData } from "../../../hooks/Method";
import { Form } from "../../../layout";
import { Button, Input } from "../../../controls";
import { Box, Divider, Grid } from "@mui/material";
import { toast } from "react-toastify";
import FeaturesPermissionForm from "./AccessFields/FeaturesPermissionForm";

const AddEditRole = ({ setShowForm, updData, setRefreshKey }) => {
  const { t } = useTranslation();
  const { UserRoleMdl } = Model();
  const [featuresAccess, setFeaturesAccess] = useState({});

  const [loading, setLoading] = useState(false);
  const { values, setValues, errors, setErrors, handleInpChg } =
    UseForm(UserRoleMdl);

  const validateForm = () => {
    let temp = {};
    temp.title = values.title !== "" ? "" : t("titleIsRequired");

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  useEffect(() => {
    if (updData && updData.id) {
      Server(controller.UserRole + action.GetById).getById(
        updData.id,
        (res) => {
          var val = res.result;
          if (val && val.id) {
            setValues({ ...val });
            setFeaturesAccess({ ...val.featuresAccess });
          } else toast.error(res.msg);
        }
      );
    }

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updData]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      const onComplete = (res) => {
        setRefreshKey((prev) => prev + 1);
        setLoading(false);
        setShowForm(false);
        // Alert
        res?.status === 200 && res.msg
          ? toast.success(res.msg)
          : toast.error(res.msg);
      };

      if (updData && updData.id) {
        Server(controller.UserRole + action.Put).put(
          ToFormData({
            ...values,
            featuresAccess,
            updateDate: new Date().toLocaleString(),
          }),
          onComplete
        );
      } else {
        Server(controller.UserRole + action.Post).post(
          ToFormData({
            ...values,
            featuresAccess,
            createDate: new Date().toLocaleString(),
          }),
          onComplete
        );
      }
    }
  };

  return (
    <Form noValidate onSubmit={handleSubmit}>
      <div className="d-flex flex-wrap j-between a-center p-5 g-10">
        <div>
          <span className="border-left fs-18 ml-5 tx-upp gray-color fw-5">
            {updData?.id ? t("update") : t("create")} {t("role")}
          </span>
        </div>
        <Box className="d-flex g-5" sx={{ width: { xs: "100%", md: "auto" } }}>
          <Button
            onClick={() => setShowForm(false)}
            sx={{ width: { xs: "100%", md: "auto" } }}
            variant="text"
          >
            {t("close")}
          </Button>
          <Button
            type="submit"
            loading={loading}
            sx={{ width: { xs: "100%", md: "auto" } }}
          >
            {!updData ? t("submit") : t("saveChanges")}
          </Button>
        </Box>
      </div>
      <Divider className="mb-10" />
      <Grid container spacing={2} className="p-10">
        <Grid item xs={12} md={6}>
          <Input
            required
            size="small"
            label={t("title")}
            name="title"
            value={values.title}
            error={errors.title}
            onChange={handleInpChg}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Input
            size="small"
            label={t("subtitle")}
            name="subtitle"
            value={values.subtitle}
            onChange={handleInpChg}
            fullWidth
          />
        </Grid>
      </Grid>
      <div className="mt-10">
        <span className="border-left tx-upp fw-5 fs-14 gray-color ml-10">
          {t("defineAccessForThisRole")}
        </span>
        <Divider className="mt-5" />
        <FeaturesPermissionForm {...{ featuresAccess, setFeaturesAccess }} />
      </div>
    </Form>
  );
};

export default AddEditRole;
